import React, { useState, useEffect } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const AchievementNotification = ({ achievement, onClose }) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (achievement) {
            setShow(true);
            // 5秒後に自動で閉じる
            const timer = setTimeout(() => {
                setShow(false);
                onClose();
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [achievement, onClose]);

    if (!achievement) return null;

    return (
        <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
            <Toast 
                show={show} 
                onClose={() => {
                    setShow(false);
                    onClose();
                }}
                style={{
                    background: 'var(--success-gradient)',
                    border: 'none',
                    borderRadius: 'var(--radius-lg)',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                    color: 'white',
                    minWidth: '300px'
                }}
            >
                <Toast.Header 
                    closeButton={false}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: 'white'
                    }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'var(--spacing-md)',
                        width: '100%'
                    }}>
                        <div style={{ fontSize: '2rem' }}>
                            {achievement.icon}
                        </div>
                        <div style={{ flex: 1 }}>
                            <strong style={{ color: 'white' }}>
                                🎉 実績解除！
                            </strong>
                        </div>
                        <button
                            type="button"
                            onClick={() => {
                                setShow(false);
                                onClose();
                            }}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: 'rgba(255,255,255,0.8)',
                                fontSize: '1.2rem',
                                cursor: 'pointer',
                                padding: '0',
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            ×
                        </button>
                    </div>
                </Toast.Header>
                <Toast.Body style={{ color: 'white' }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'var(--spacing-md)'
                    }}>
                        <div style={{ fontSize: '2.5rem' }}>
                            {achievement.icon}
                        </div>
                        <div>
                            <div style={{
                                fontWeight: 'bold',
                                fontSize: '1.1rem',
                                marginBottom: 'var(--spacing-xs)'
                            }}>
                                {achievement.name}
                            </div>
                            <div style={{
                                color: 'rgba(255,255,255,0.9)',
                                fontSize: '0.9rem'
                            }}>
                                {achievement.description}
                            </div>
                        </div>
                    </div>
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

export default AchievementNotification;